import { BusinessService } from '../../_service/business.service';
import { Business } from '../../models/business.model';
import { Component, OnInit } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { AnnualPricing } from '../../models/annual-pricing.model';
import { MonthlyPricing } from '../../models/monthly-pricing.model';


@Component({
  selector: 'app-change-plans',
  standalone: false,
  providers: [provideNativeDateAdapter()],
  templateUrl: './change-plans.component.html',
  styleUrl: './change-plans.component.css.css',
})
export class ChangePlansComponent implements OnInit {
  business: Business;
  configList: any;
  // plan change page
  currentPlan: string;
  activeView: string;
  legacyPlan: boolean = false;
  allowFreeTrial: boolean = false;
  planVertical: string;
  planFrequency: string;
  freeVersion: string = 'TTFREE'; //This is the code used for changing plan type to free
  plusVersion: string = 'TTPLUS'; //This is the code used for changing plan type to plus - the second tier. It defaults to monthly
  proVersion: string = 'TTPRO'; //This is the code used for changing plan type to pro - the third tier. It defaults to monthly
  soloProPlan: string = 'SOLOPRO';
  teamProPlan: string = 'TEAMPRO';
  soloBizPlan: string = 'SOLOBUS';
  teamBizPlan: string = 'TEAMBUS';
  pricing: any;
  recruiterMonthlyPlan: string = '28';
  recruiterAnnualPlan: string = '29';
  nonProfitPlan: boolean = false;
  planId: number;

  constructor(private businessService: BusinessService) {
    this.business = businessService.getBusiness();
    this.currentPlan = this.businessService.getLoginResponse().planName;
    this.configList = this.businessService.getConfigList();
  }

  ngOnInit() {
    this.assignMonthlyAnnualDefaults();
    console.log('What are my values?' + this.currentPlan + ':' + this.activeView + ':' + this.business.billingInfoAdded);
  }


  assignMonthlyAnnualDefaults() {
    this.planId = this.businessService.getLoginResponse().planId;
    switch (this.planId) {
      case 10:
      case 2:
        this.currentPlan = 'TTFREE';
        this.activeView = 'ANNUAL';
        break;
      case 14:
        this.currentPlan = 'TTPLUS';
        this.activeView = 'MONTHLY';
        break;
      case 30:
        this.legacyPlan = true;
        break;
      case 45:
        this.currentPlan = 'SOLOPRO';
        this.activeView = 'MONTHLY';
        break;
      case 34:
        this.currentPlan = 'SOLOPRO';
        this.activeView = 'ANNUAL';
        break;
      case 31:
        this.legacyPlan = true;
        break;
      case 46:
        this.currentPlan = 'TEAMPRO';
        this.activeView = 'MONTHLY';
        break;
      case 35:
        this.currentPlan = 'TEAMPRO';
        this.activeView = 'ANNUAL';
        break;
      case 32:
        this.legacyPlan = true;
        break;
      case 44:
        this.currentPlan = 'SOLOBUS';
        this.activeView = 'MONTHLY';
        break;
      case 36:
        this.currentPlan = 'SOLOBUS';
        this.activeView = 'ANNUAL';
        break;
      case 33:
        this.legacyPlan = true;
        break;
      case 43:
        this.currentPlan = 'TEAMBUS';
        this.activeView = 'MONTHLY';
        break;
      case 37:
        this.currentPlan = 'TEAMBUS';
        this.activeView = 'ANNUAL';
        break;
      case 28:
        this.currentPlan = 'RECRUITERMONTHLY';
        this.activeView = 'ANNUAL';
        break;
      case 29:
        this.currentPlan = 'RECRUITERANNUAL';
        this.activeView = 'ANNUAL';
        break;
      case 38:
      case 39:
      case 40:
      case 41:
        this.nonProfitPlan = true;
        this.activeView = 'ANNUAL';
        break;
      case 16:
      case 5:
        this.currentPlan = 'TTSOLOPRO';
        this.activeView = 'MONTHLY';
        this.legacyPlan = true;
        break;
      case 20:
      case 24:
        this.currentPlan = 'TTSOLOPRO';
        this.activeView = 'ANNUAL';
        this.legacyPlan = true;
        break;
      case 17:
      case 7:
        this.currentPlan = 'TTTEAMPRO';
        this.activeView = 'MONTHLY';
        this.legacyPlan = true;
        break;
      case 21:
      case 25:
        this.currentPlan = 'TTTEAMPRO';
        this.activeView = 'ANNUAL';
        this.legacyPlan = true;
        break;
      case 18:
      case 12:
        this.currentPlan = 'TTSOLOBIZ';
        this.activeView = 'MONTHLY';
        this.legacyPlan = true;
        break;
      case 22:
      case 26:
        this.currentPlan = 'TTSOLOBIZ';
        this.activeView = 'ANNUAL';
        this.legacyPlan = true;
        break;
      case 19:
      case 8:
        this.currentPlan = 'TTTEAMBIZ';
        this.activeView = 'MONTHLY';
        this.legacyPlan = true;
        break;
      case 23:
      case 27:
        this.currentPlan = 'TTTEAMBIZ';
        this.activeView = 'ANNUAL';
        this.legacyPlan = true;
        break;
      default:
        this.legacyPlan = true;
        this.activeView = 'ANNUAL';
        break;
    }
    if (this.planId === 28 || this.planId === 29) {
      this.planVertical = 'recruiter';
    } else {
      this.planVertical = 'general';
    }
    this.changeActiveView(this.activeView);
  }

  changeActiveView(view: string) {
    this.activeView = view;
    if (this.activeView === 'ANNUAL') {
      this.pricing = new AnnualPricing();
    } else if (this.activeView === 'MONTHLY') {
      this.pricing = new MonthlyPricing();
    }
    switch (this.planId) {
      case 20:
      case 21:
      case 22:
      case 23:
      case 24:
      case 25:
      case 26:
      case 27:
      case 34:
      case 35:
      case 36:
      case 37:
        this.planFrequency = 'ANNUAL';
        break;
      default:
        this.planFrequency = 'MONTHLY';
    }
  }

  switchPlans(plan: any, something: string) {

  }
}
